'use strict';

var Wreqr = require('base/Colido.Wreqr');

/**
 * Wreqr definitions for the global module
 *
 * @category   Module
 * @module     global
 * @copyright  Copyright (c) 2016, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@h-m.io>
 */
var GlobalModuleWreqr = Wreqr.extend({
    /**
     * Name for the channel
     * @type {String}
     */
    name: 'global',

    /**
     * Name of the global module
     * We use this for dynamic referencing of global collections and models
     * @type {String}
     */
    globalModuleName: null,

    /**
     * Initializes the class and attaches the handler based on names
     * @param {object} options Options, that were passed be initiating the object
     */
    initialize: function(options) {
        Wreqr.prototype.initialize.apply(this, arguments);

        this.globalModuleName = this.getOption('module').moduleName || 'Global';
    },

    /**
     * Returns the modals collection
     * @returns {ModalsCollections}
     */
    requestModalsCollection: function() {
        return App[this.globalModuleName].modalsCollection;
    },

    /**
     * Returns the currencies collection
     * @returns {CurrenciesCollections}
     */
    requestCurrenciesCollection: function() {
        return App[this.globalModuleName].currenciesCollection;
    },

    /**
     * Returns the currencies collection
     * @returns {CurrenciesCollections}
     */
    requestScannersCollection: function() {
        return App[this.globalModuleName].scannersCollection;
    },

    /**
     * Returns the system languages collection
     * @returns {SystemLanguagesCollection}
     */
    requestSystemLanguagesCollection: function() {
        return App[this.globalModuleName].systemLanguagesCollection;
    },

    /**
     * Returns the countries collection
     * @returns {CountriesCollection}
     */
    requestCountriesCollection: function() {
        return App[this.globalModuleName].countriesCollection;
    },

    /**
     * Returns the catalog subtypes collection
     * @returns {SubtypesCollection}
     */
    requestSubtypesCollection: function() {
        return App[this.globalModuleName].subtypesCollection;
    },
});

module.exports = GlobalModuleWreqr;